import clsx from "clsx";
import { useRef, useState } from "react";
import utils from "../../../../business/helper/Utils";
import { useClickOutside } from "../../../../hooks/useClickOutside";

const Select = ({
  value,
  onChange,
  options,
  title,
  toLowerCase = false,
  icon,
  wrappers = [],
  className = "",
}) => {
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const selectRef = useRef(null);

  useClickOutside(selectRef, () => {
    setIsOptionsOpen(false);
  });

  const handleSelect = (option) => {
    onChange({
      target: {
        value: toLowerCase ? String(option).toLowerCase() : option,
      },
    });
  };

  const Logic = () => (
    <div
      ref={selectRef}
      className="border border-dimgray-400 rounded-lg py-2.5 px-3 cursor-pointer"
      onClick={() => setIsOptionsOpen((prev) => !prev)}
    >
      <div
        // value={value}
        // onChange={onChange}
        className="w-full min-w-12 focus:outline-none flex items-center justify-between"
      >
        {
          options.find(
            (option) => option.value.toLowerCase() === value.toLowerCase()
          )?.title
        }
        {icon || (
          <svg
            className={clsx(
              "w-4 h-4 transform transition-transform",
              isOptionsOpen && "rotate-180"
            )}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        )}
        {/* {options.map((option) => (
            <option value={toLowerCase ? String(option).toLowerCase() : option}>
              {option}
            </option>
          ))} */}
      </div>

      {isOptionsOpen && (
        <ul className="absolute top-20 left-0 w-full rounded-lg shadow-select z-30 bg-white text-dimgray-200">
          {options.map((option) => (
            <li
              key={option.value}
              className="px-6 py-1.5 leading-6 hover:bg-whitesmoke-400 first:rounded-t-lg last:rounded-b-lg border-b last:border-none border-whitesmoke-100"
              onClick={() => {
                handleSelect(option.value);
              }}
            >
              {option.title}
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  return (
    <div
      className={"relative flex flex-col gap-1.5 max-w-[200px] " + className}
    >
      <p className="font-semibold">{title}</p>
      {wrappers.length ? (
        <div className="flex gap-2 items-center" style={{ whiteSpace: "nowrap" }}>
          <p>{wrappers[0]}</p>
          <Logic />
          {wrappers.length > 1 && <p>{wrappers[1]}</p>}
        </div>
      ) : (
        <Logic />
      )}
    </div>
  );
};

export default Select;
